/* eslint-disable max-len */
import { DeliveryClient, TypeResolver } from 'kentico-cloud-delivery';
import DebugOptionsService from 'services/DebugOptions.service';

import {
  KENTICO_TYPES,
  PROJECT_ID,
  PREVIEW_API_KEY,
} from 'common/consts/kentico';

/* Disable ESlint rule for this file */
/* eslint no-console: "off" */

import {
  Product,
  HeroImage,
  ThreeColumnGrid,
  Column,
  Header,
  Accordion,
  AccordionItem,
  Banner,
  SimpleAccordion,
  SimpleAccordionItem,
  CardSlider,
  CardSlide,
  DownloadBar,
  File,
  TwoColumnGrid,
  ImagedSection,
  ContactForm,
  ImageSlide,
  ImageSlider,
  CallUs,
  ContactPerson,
  Link,
  HorizontallyNavigableContent,
  ContentWithHeader,
  SEO,
  ShareLink,
  HtmlModifier,
  Translations,
  Core,
  BlogArticle,
  BlogAuthor,
  Newsletter,
  LinkBanner,
  DividedBlogSection,
  BlogImageSlider,
  BlogImageSlide,
  LinkToProduct,
  ProductSlider,
  ProductSlide,
  CroppedAsset,
  Calculator,
  CalculatorValue,
  BlogCategoryTranslation,
  ArticleSlide,
  ArticleSlider,
  ImageLink,
  TitleAndSubtitle,
  FAQAccordion,
  FAQAccordionItem,
  ForInvestorsItems,
  ForInvestorsSection,
  ForInvestorsLinkedItem,
  GlobalMetaTags,
  GlobalMetaTag,
  NewsletterThankYouPage,
  ContactFormSupport,
} from "models";
import { DEBUG_OPTION_MODE, DEBUG_VALUE_MODE_PREVIEW } from 'common/consts/debugOptionConsts';
import LanguageService from 'services/Language.service';


// configure type resolvers
const typeResolvers = [
  new TypeResolver(KENTICO_TYPES.PRODUCT, () => new Product()),
  new TypeResolver(KENTICO_TYPES.COLUMN, () => new Column()),
  new TypeResolver(KENTICO_TYPES.HERO_IMAGE, () => new HeroImage()),
  new TypeResolver(KENTICO_TYPES.THREE_COLUMN_GRID, () => new ThreeColumnGrid()),
  new TypeResolver(KENTICO_TYPES.HEADER, () => new Header()),
  new TypeResolver(KENTICO_TYPES.ACCORDION, () => new Accordion()),
  new TypeResolver(KENTICO_TYPES.ACCORDION_ITEM, () => new AccordionItem()),
  new TypeResolver(KENTICO_TYPES.BANNER, () => new Banner()),
  new TypeResolver(KENTICO_TYPES.SIMPLE_ACCORDION, () => new SimpleAccordion()),
  new TypeResolver(KENTICO_TYPES.SIMPLE_ACCORDION_ITEM, () => new SimpleAccordionItem()),
  new TypeResolver(KENTICO_TYPES.CARD_SLIDER, () => new CardSlider()),
  new TypeResolver(KENTICO_TYPES.CARD_SLIDE, () => new CardSlide()),
  new TypeResolver(KENTICO_TYPES.DOWNLOAD_BAR, () => new DownloadBar()),
  new TypeResolver(KENTICO_TYPES.FILE_LINK, () => new File()),
  new TypeResolver(KENTICO_TYPES.TWO_COLUMN_GRID, () => new TwoColumnGrid()),
  new TypeResolver(KENTICO_TYPES.IMAGED_SECTION, () => new ImagedSection()),
  new TypeResolver(KENTICO_TYPES.CONTACT_FORM, () => new ContactForm()),
  new TypeResolver(KENTICO_TYPES.CONTACT_FORM_SUPPORT, () => new ContactFormSupport()),
  new TypeResolver(KENTICO_TYPES.IMAGE_SLIDE, () => new ImageSlide()),
  new TypeResolver(KENTICO_TYPES.IMAGE_SLIDER, () => new ImageSlider()),
  new TypeResolver(KENTICO_TYPES.CALL_US, () => new CallUs()),
  new TypeResolver(KENTICO_TYPES.CONTACT_PERSON, () => new ContactPerson()),
  new TypeResolver(KENTICO_TYPES.ContactLink, () => new Link()),
  new TypeResolver(KENTICO_TYPES.HORIZONTALLY_NAVIGABLE_CONTENT, () => new HorizontallyNavigableContent()),
  new TypeResolver(KENTICO_TYPES.CONTENT_WITH_HEADER, () => new ContentWithHeader()),
  new TypeResolver(KENTICO_TYPES.SEO, () => new SEO()),
  new TypeResolver(KENTICO_TYPES.SHARE_LINK, () => new ShareLink()),
  new TypeResolver(KENTICO_TYPES.HTML_MODIFIER, () => new HtmlModifier()),
  new TypeResolver(KENTICO_TYPES.TRANSLATIONS, () => new Translations()),
  new TypeResolver(KENTICO_TYPES.CORE, () => new Core()),
  new TypeResolver(KENTICO_TYPES.BLOG_ARTICLE, () => new BlogArticle()),
  new TypeResolver(KENTICO_TYPES.BLOG_AUTHOR, () => new BlogAuthor()),
  new TypeResolver(KENTICO_TYPES.NEWSLETTER, () => new Newsletter()),
  new TypeResolver(KENTICO_TYPES.LINK_BANNER, () => new LinkBanner()),
  new TypeResolver(KENTICO_TYPES.DIVIDED_BLOG_SECTION, () => new DividedBlogSection()),
  new TypeResolver(KENTICO_TYPES.BLOG_IMAGE_SLIDER, () => new BlogImageSlider()),
  new TypeResolver(KENTICO_TYPES.BLOG_IMAGE_SLIDE, () => new BlogImageSlide()),
  new TypeResolver(KENTICO_TYPES.LINK_TO_PRODUCT, () => new LinkToProduct()),
  new TypeResolver(KENTICO_TYPES.PRODUCT_SLIDER, () => new ProductSlider()),
  new TypeResolver(KENTICO_TYPES.PRODUCT_SLIDE, () => new ProductSlide()),
  new TypeResolver(KENTICO_TYPES.CROPPED_ASSET, () => new CroppedAsset()),
  new TypeResolver(KENTICO_TYPES.CALCULATOR, () => new Calculator()),
  new TypeResolver(KENTICO_TYPES.CALCULATOR_VALUE, () => new CalculatorValue()),
  new TypeResolver(KENTICO_TYPES.BLOG_CATEGORY_TRANSLATION, () => new BlogCategoryTranslation()),
  new TypeResolver(KENTICO_TYPES.ARTICLE_SLIDE, () => new ArticleSlide()),
  new TypeResolver(KENTICO_TYPES.ARTICLE_SLIDER, () => new ArticleSlider()),
  new TypeResolver(KENTICO_TYPES.IMAGE_LINK, () => new ImageLink()),
  new TypeResolver(KENTICO_TYPES.TITLE_AND_SUBTITLE, () => new TitleAndSubtitle()),
  new TypeResolver(KENTICO_TYPES.FAQ_ACCORDION, () => new FAQAccordion()),
  new TypeResolver(KENTICO_TYPES.FAQ_ACCORDION_ITEM, () => new FAQAccordionItem()),
  new TypeResolver(KENTICO_TYPES.FOR_INVESTORS, () => new ForInvestorsItems()),
  new TypeResolver(KENTICO_TYPES.FOR_INVESTORS_SECTION, () => new ForInvestorsSection()),
  new TypeResolver(KENTICO_TYPES.FOR_INVESTORS_ITEM, () => new ForInvestorsLinkedItem()),
  new TypeResolver(KENTICO_TYPES.GLOBAL_META_TAGS, () => new GlobalMetaTags()),
  new TypeResolver(KENTICO_TYPES.GLOBAL_META_TAG, () => new GlobalMetaTag()),
  new TypeResolver(KENTICO_TYPES.NEWSLETTER_THANK_YOU_PAGE, () => new NewsletterThankYouPage()),
];

const isPreview = !!PREVIEW_API_KEY;

if (isPreview) {
  console.info('PREVIEW MODE IS ENABLED');
}

const defaultLanguage = LanguageService.getLanguage();

const defaultDeliveryClientOptions = {
  projectId: PROJECT_ID,
  typeResolvers: [...typeResolvers],
  enablePreviewMode: false,
  defaultLanguage,
  modularContentResolver: {
    modularContentWrapperTag: 'div',
  },
  baseUrl: process.env.REACT_APP_PROXY_BASE_URL,
  basePreviewUrl: process.env.REACT_APP_PROXY_BASE_URL,
};

const debugDeliveryClientOptions = DebugOptionsService.isDebug() ? {
  projectId: PROJECT_ID,
  typeResolvers: [...typeResolvers],
  previewApiKey: PREVIEW_API_KEY,
  enablePreviewMode: DebugOptionsService.getOptionValueByName(DEBUG_OPTION_MODE) === DEBUG_VALUE_MODE_PREVIEW && isPreview,
  defaultLanguage,
  modularContentResolver: {
    modularContentWrapperTag: 'div',
  },
  baseUrl: process.env.REACT_APP_PROXY_BASE_URL,
  basePreviewUrl: process.env.REACT_APP_PROXY_BASE_URL,
} : null;

class CustomDeliveryClient extends DeliveryClient {
  setLanguage(language) {
    if (this.config) {
      this.config.defaultLanguage = language;
    }
  }
}

export default new CustomDeliveryClient(debugDeliveryClientOptions || defaultDeliveryClientOptions);



// WEBPACK FOOTER //
// ./src/services/kenticoClient.js